module.exports = __webpack_public_path__ + "static/media/Pin_Job_FlatTire.9f88fd34.svg";